import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Icon from "../elements/icon";

const { arrayOf, shape, string, number, oneOfType, node } = PropTypes;

export default class CardAnalytics extends React.Component {
  static displayName = "CardAnalytics";

  static propTypes = {
    className: string,
    data: arrayOf(
      shape({
        label: string.isRequired,
        value: oneOfType([string, number, node]),
        icon: string,
      })
    ),
  };

  render() {
    const size = _.size(this.props.data);

    return (
      <div className={classNames("et--card-analytics", this.props.className)}>
        {_.map(this.props.data, function (item) {
          const isEmpty = !item.value || [0, "0", "$0", "0%"].includes(item.value);

          return (
            <div
              key={item.label}
              className={classNames("et--card-analytics--column", {
                "is-empty": isEmpty,
              })}
              style={{ width: 100 / size + "%" }}
            >
              <div className="et--card-analytics--data">
                <strong>{item.value}</strong>
                {item.icon ? <Icon icon={item.icon} /> : undefined}
              </div>
              <div>{item.label}</div>
            </div>
          );
        })}
      </div>
    );
  }
}
